export type ContractFieldsProps = {
  id?: string
  name: string
  archivedAt?: Date | null
  new?: boolean
  edited?: boolean
  archivable?: boolean
}

type Language = 'spanish' | 'french' | 'german' | 'portuguese'

export const countryPrefixes: Record<string, Language> = {
  es: 'spanish',
  fr: 'french',
  de: 'german',
  pt: 'portuguese',
}
